module.exports = __webpack_public_path__ + "static/GorditaBlack-BlackItalic-53f1079df3de2677bd5ff287395605f0.woff";